import { render, staticRenderFns } from "./NovoEditCargo.vue?vue&type=template&id=cab39ad4"
import script from "./NovoEditCargo.vue?vue&type=script&lang=js"
export * from "./NovoEditCargo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports